module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.82ad21ab.png";